export const FETCH_LIST_MATCH_CROWDS_SUCCEEDED = 'FETCH_LIST_MATCH_CROWDS_SUCCEEDED'
export const FETCH_MARKETS_WITH_NPI_SUCCEEDED = 'FETCH_MARKETS_WITH_NPI_SUCCEEDED'
export const POST_CREATE_PROJECT = 'POST_CREATE_PROJECT'
export const POST_CREATE_PROJECT_SUCCEEDED = 'POST_CREATE_PROJECT_SUCCEEDED'
export const POST_CREATE_PROJECT_FAILED = 'POST_CREATE_PROJECT_FAILED'